export const OwnerTypes = {
    USER: "USER",
    WORKSPACE: "WORKSPACE",
    TEAM: "TEAM",
    CLIMATE_ACTION: "CLIMATE_ACTION",
    PROJECT: "PROJECT",
    TASK: "TASK",
    DATA_REQUEST_ENTITY: "DATA_REQUEST_ENTITY",
};
const OWNER_TYPE_MAP = Object.fromEntries(Object.values(OwnerTypes).map((ownerType) => [ownerType, ownerType]));
export const ownerTypeFromString = (str) => OWNER_TYPE_MAP[str];
